import React, { useContext } from 'react';
import './SideBar.scss';
import { layoutContext } from '../CloudPakForAiops';
import { Scenario } from '../../data/constants';

const SideBar = ({ copy }: any) => {
  const { profile, setProfile } = useContext(layoutContext);
  const { setCurrentScenario } = useContext(layoutContext);
  const { setCurrentVideo } = useContext(layoutContext);

  const getButton = (title: string, description: string, url: string) => {
    return (
      <>
        <button
          onClick={() => {
            setCurrentVideo(url);
            setCurrentScenario(Scenario.video);
          }}
        >
          <span>
            <strong>{title}</strong>
            <br />
            {description}
          </span>
        </button>
      </>
    );
  };

  return (
    <>
      <div className="cloud-pak-for-aiops_navigation-wrapper">
        <h2>{copy.title}</h2>

        <div className="tabs">
          <input
            className="tab-input"
            type="radio"
            id="tab1"
            name="tab"
            defaultChecked={profile === 'sre'}
            onClick={() => setProfile('sre')}
          />
          <label htmlFor="tab1" className="tab-label">
            {copy.items[0].type}
          </label>

          <input
            className="tab-input"
            type="radio"
            id="tab2"
            name="tab"
            defaultChecked={profile === 'admin'}
            onClick={() => setProfile('admin')}
          />
          <label htmlFor="tab2" className="tab-label">
            {copy.items[1].type}
          </label>

          <div className="tab-content">
            <p>{copy.items[0].title}</p>
            <h4>
              {copy.label} ({copy.items[0].useCases.length})
            </h4>

            {copy.items[0].useCases.map((item: any) => {
              return getButton(item.title, item.copy, item.videoId);
            })}
          </div>
          <div className="tab-content">
            <p>{copy.items[1].title}</p>
            <h4>
              {copy.label} ({copy.items[1].useCases.length})
            </h4>
            {copy.items[1].useCases.map((item: any) => {
              return getButton(item.title, item.copy, item.videoId);
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
